import { html } from 'lit';
import type { TefComsTriStateButton } from '@src/components/TefComsTriStateButton';

export function triStateButtonTemplate(this: TefComsTriStateButton) {
  return html`
    <one-cluster gap="none" no-wrap class="tef-coms-tri-state-button">
      ${this.createButton('granted')}
      ${this.createButton('revoked')}
    </one-cluster>
  `;
}
